module.exports = __webpack_public_path__ + "img/manajemen-pinjaman.45e48e92.svg";